/**
 * Export `navBarHeight` constant.
 */

export const navBarHeight = 125;
